<div class="webcam-capture-form" [style.margin]="margin">
  <!-- Título -->
  <label class="form-control__label">
    {{title}}{{required ? ' *' : ''}}
  </label>

  <!-- Descripción -->
  <p class="description" *ngIf="description">
    {{description}}
  </p>

  <!-- Error Message -->
  <div *ngIf="showError && errorMessage" class="error-message">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{errorMessage}}</span>
  </div>

  <!-- Webcam Container -->
  <div class="webcam-container">
    <!-- Webcam Stream -->
    <div class="webcam-stream" *ngIf="showWebcam">
      <!-- Video Element -->
      <div class="video-container">
        <video
          #videoElement
          [width]="width"
          [height]="height"
          autoplay
          muted
          playsinline
          class="webcam-video">
        </video>
        <button
          *ngIf="multipleWebcamsAvailable"
          class="camera-switch-btn"
          (click)="toggleCamera()"
          type="button"
          [title]="getCurrentCameraTooltip()">
          {{ getCurrentCameraIcon() }}
        </button>
        
        <!-- Botón de captura flotante -->
        <button
          *ngIf="showCaptureButton && captureButtonMode === 'floating'"
          class="capture-floating-btn"
          (click)="triggerSnapshot()"
          type="button"
          title="Capturar foto">
          <i class="pi pi-camera"></i>
        </button>
      </div>

      <!-- Hidden Canvas for Capture -->
      <canvas
        #canvasElement
        [width]="width"
        [height]="height"
        style="display: none;">
      </canvas>

      <!-- Capture Controls -->
      <div class="capture-controls" *ngIf="showCaptureButton && captureButtonMode === 'external'">
        <p-button
          label="Capturar Foto"
          icon="pi pi-camera"
          (onClick)="triggerSnapshot()"
          styleClass="p-button-success">
        </p-button>
      </div>
    </div>

    <!-- Photo Info Panel (Always visible when there's a photo) -->
    <div class="photo-info-panel" *ngIf="value && showPreview">
      <div class="info-header">
        <i class="pi pi-check-circle" style="color: #28a745;"></i>
        <span>Foto Capturada</span>

        <!-- Delete icon in top-right corner -->
        <button
          class="delete-icon"
          (click)="deletePhoto()"
          type="button"
          title="Eliminar foto">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="info-content">
        <!-- Thumbnail with full size view -->
        <div class="photo-thumbnail">
          <div class="thumbnail-container">
            <img [src]="value.base64Data"
                 [alt]="value.fileName"
                 class="thumbnail-img"
                 (click)="openFullSizeImage()"
                 title="Haz clic para ver en tamaño completo" />

            <!-- Full size view button overlay -->
            <div class="full-size-overlay">
              <button
                class="full-size-btn"
                (click)="openFullSizeImage()"
                type="button"
                title="Ver en tamaño completo">
                <i class="pi pi-external-link"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Photo Info -->
        <div class="photo-info">
          <p><strong>Archivo:</strong> {{value.fileName}}</p>
          <p><strong>Tamaño:</strong> {{formatBytes(value.size)}}</p>
          <p><strong>Fecha:</strong> {{value.timestamp | date:'short'}}</p>
          <p><strong>Resolución:</strong> {{getImageDimensions()}}</p>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="photo-actions" *ngIf="showRetakeButton">
        <p-button
          label="Nueva Foto"
          icon="pi pi-refresh"
          (onClick)="retakePhoto()"
          styleClass="p-button-secondary">
        </p-button>
      </div>
    </div>

    <!-- Camera Not Available -->
    <div class="camera-unavailable" *ngIf="!showWebcam && !value">
      <i class="pi pi-video-slash"></i>
      <p>No se pudo acceder a la cámara</p>
      <p-button
        label="Reintentar"
        icon="pi pi-refresh"
        (onClick)="toggleWebcam()"
        styleClass="p-button-outlined">
      </p-button>
    </div>
  </div>

  <!-- Full Size Image Modal -->
  <div class="full-size-modal" *ngIf="showFullSizeModal" (click)="closeFullSizeImage()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Vista Completa</h3>
        <button
          class="close-btn"
          (click)="closeFullSizeImage()"
          type="button"
          title="Cerrar">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="modal-body">
        <img [src]="value?.base64Data"
             [alt]="value?.fileName"
             class="full-size-img" />
      </div>

      <div class="modal-footer">
        <p><strong>Archivo:</strong> {{value?.fileName}}</p>
        <p><strong>Tamaño:</strong> {{value ? formatBytes(value.size) : ''}}</p>
        <p><strong>Fecha:</strong> {{value?.timestamp | date:'short'}}</p>
        <p><strong>Resolución:</strong> {{getImageDimensions()}}</p>
      </div>
    </div>
  </div>
</div>
